enum UserProfile {
  USER = 'USER',
  SUPERVISOR = 'SUPERVISOR',
  GP = 'GP',
  CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS',
}

export default UserProfile;
